import { render } from "./BudgetButton.vue?vue&type=template&id=701b7fea&lang=pug"
import script from "./BudgetButton.vue?vue&type=script&lang=js"
export * from "./BudgetButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__